import React, { useEffect, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Image, Row } from '@thd-olt-component-react/core-ui';
import { isEmpty } from 'lodash';
import { useLocation } from '@thd-olt-component-react/router';
import { useStore } from '../../../store';
import { generateImageSource } from '../../../utils/generateImageSource';
import { EXP_ROUTES } from '../../../utils/constants';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import GoBackNavLink from '../../common/GoBackNavLink';
import PageHeader from '../../common/PageHeader/PageHeader';
import CreateJobPostingLoader from './CreateJobPostingLoader';

const _CreateJobPostingHeader = () => {
  const backToObj = {
    backTo: 'Job Postings',
    backToUrl: EXP_ROUTES.JOB_POSTINGS
  };

  const { createNewJobPosting, editedJobPosting, setEditedJobPosting } = useContext(JobPostingContext);
  const {
    companyProfileStore: {
      getCompanyProfile,
      companyProfile
    }
  } = useStore();
  const location = useLocation();

  useEffect(() => {
    if (isEmpty(companyProfile)) {
      getCompanyProfile();
    }
  }, []);

  useEffect(() => {
    setEditedJobPosting((prevState) => ({
      ...prevState,
      companyName: companyProfile?.name || '',
      companyUrl: companyProfile?.url || '',
      companyDescription: companyProfile?.description || ''
    }));
  }, [companyProfile]);

  useEffect(() => {
    if (isEmpty(editedJobPosting)) {
      const jobTemplate = location?.state?.jobTemplate;
      createNewJobPosting(
        jobTemplate?.jobDescription,
        jobTemplate?.educationAndSkills,
        jobTemplate?.tradeType,
        jobTemplate?.yearsOfExperience,
        companyProfile?.name,
        companyProfile?.url,
        companyProfile?.description
      );
    }
  }, [editedJobPosting]);

  if (isEmpty(editedJobPosting)) {
    return <CreateJobPostingLoader />;
  }

  return (
    <>
      <PageHeader>Path to Pro Network</PageHeader>
      <Row>
        <GoBackNavLink backToStr={backToObj.backTo} fallbackUrl={backToObj.backToUrl} />
      </Row>
      <Row>
        <div className="create-job-posting__sub-title">
          <Image
            src={generateImageSource('/images/v1/path-to-pro/create_new_job_icon.svg')}
            className="create-job-posting__create-posting-icon"
            alt="create-job-posting-icon"
          />

          Create New Job Posting
        </div>
      </Row>
      <Row>
        <p className="create-job-posting__p">
          Please provide some details about the work/job you are needing help with. The following information will be submitted into our candidate pool, and interested candidates will reach out to you.
        </p>
      </Row>
    </>
  );
};

export const CreateJobPostingHeader = observer(_CreateJobPostingHeader);
